<template>
    <v-dialog v-model="dialogListar" fullscreen hide-overlay transition="dialog-bottom-transition" persistent>
        <v-card >
            <v-toolbar flat dark color="primary">
                <v-btn icon dark @click="cancelar()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Nueva acción Masiva: {{this.datosAccion.grupo.nombre}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn 
                        dark 
                        text 
                        @click="guardar()"
                        :disabled="invalidDesc || invalidAmbitos"
                    >
                        Guardar
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-text class="pr-1 pl-1">
                <v-card :loading="loading" class="mt-5">
                    <v-card-title>
                        <v-text-field class="mb-5 ml-2" v-model="search" append-icon="mdi-file-search-outline" label="Buscar" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table 
                        :headers="headers" 
                        :items="clientes" 
                        :search="search" 
                        v-model="clientesSelec"
                        show-select
                        item-key="cliente_id"
                        class="elevation-1"
                        hide-default-footer
                        disable-pagination 
                        :item-class="clientesNoSelec"
                    >
                        <template v-slot:item.tiempoAccion="{ item }"> 
                            <v-select class="text-body-2" style="width: 8em;" v-model="item.tiempoAccion" :items="tiempoAccion" v-on:change="cambioForzado()"></v-select>
                        </template>  
                        <template v-slot:item.ambito="{ item }">
                            <v-select class="text-body-2" style="width: 14em;" :items="item.ambitos" item-text="ambito" v-on:change="comprobarAmbitos()" v-model="item.ambito" return-object></v-select>
                        </template>     
                        <template v-slot:item.contrato="{ item }">
                            <v-select class="text-body-2" style="width: 14em;" :items="item.contratos_ordenados" item-text="tipoContrato" v-on:change="contenidoAmbitos(item)" v-model="item.contrato" return-object></v-select>
                        </template>   
                        <template v-slot:item.gradourgencia="{ item }">
                            <v-select class="text-body-2" style="width: 14em;" :items="gradosurgencia" item-text="urgencia" v-model="item.gradourgencia" return-object></v-select>
                        </template>  
                        <template v-slot:item.descripcion="{ item }">
                            <v-textarea class="text-body-2" style="min-width: 10em;" v-model="item.descripcion" rows="1" @input="contenidoDesc()"></v-textarea>
                        </template> 
                    </v-data-table>
                </v-card>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import parseDate from "@/mixins/formatearFecha";
import formatDate from "@/mixins/formatearFecha";
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
export default {
    name: 'FullDialog',
    props: ['ambitos', 'contratos', 'tiempoAccion', 'clientes', 'gradosurgencia', 'comerciales'],
    mixins: [formatDate, parseDate],
    data: () => ({
        datos: {},
        selectAllFH: false,
        checkIndet: false,
        headers: [
            {
                text: 'Cliente',
                filterable: true,
                value: 'name',
            },
            {
                text: 'Tiempo',
                filterable: false,
                value: 'tiempoAccion',
            },
            {
                text: 'Contrato',
                filterable: false,
                value: 'contrato',
            },
            {
                text: 'Ámbito',
                filterable: false,
                value: 'ambito',
            },
            {
                text: 'Urgencia',
                filterable: false,
                value: 'gradourgencia',
            },
            {
                text: 'Fecha',
                filterable: false,
                value: 'fecha',
            },
            {
                text: 'Entrada',
                filterable: false,
                value: 'entrada',
            },
            {
                text: 'Salida',
                filterable: false,
                value: 'salida',
            },
            {
                text: 'Comentario',
                filterable: false,
                value: 'descripcion',
            },
        ],
        loading: false,
        search:'',
        clientesSelec: [],
        invalidDesc: true,
        invalidAmbitos: true,
        cambioDia: false,
    }),
    created(){
        if (!this.tecnicos.length) {
            this.$store.dispatch("usuarios/getUsuarios");
        }
        if(this.datosAccion.descripcion){
          this.invalidDesc = false;
        }

        if(this.datosAccion.orden_contratos){
            if(this.datosAccion.orden_contratos.includes("[")){
                this.datosAccion.orden_contratos = this.datosAccion.orden_contratos.slice(1,-1);
            }
            this.datosAccion.orden_contratos = this.datosAccion.orden_contratos.split(',').map(Number);
        }
        this.clientesSelec = this.clientes; //de primeras seleccionamos todos los clientes
        this.inicializarDatos();
    },
    methods: {
        ...mapActions('accionesMasivas', ['setDialogListar', 'setDatosAccion']),
        ...mapActions(['setLoading', 'setSnackbar']),
        inicializarDatos(){
            this.clientes.forEach(cliente => {
                if(this.datosAccion.orden_contratos){
                    cliente.contratos_ordenados = [];
                    this.datosAccion.orden_contratos.forEach(idCotnrato => { //hago un array ordenando los contratos de cliente teniendo en cuenta el array de orden_contratos del grupo
                        let contrato = cliente.contratos.find(c => c.contrato_id === idCotnrato);
                        if(contrato){
                            contrato.contrato = contrato.tipoContrato;
                            cliente.contratos_ordenados.push(contrato);
                        }
                    });
                }else{
                    cliente.contratos_ordenados = cliente.contratos;
                    let ptoCerrado = cliente.contratos.find(c => c.id === 7);
                    // if(ptoCerrado) cliente.contratos_ordenados.push(cliente.contratos.splice(cliente.contratos.indexOf(ptoCerrado), 1)[0]);
                    if(ptoCerrado) cliente.contratos.splice(cliente.contratos.indexOf(ptoCerrado), 1)[0];
                }
                
                cliente.tiempoAccion = this.datosAccion.tiempoAccion;
                cliente.ambito = this.datosAccion.ambito;
                cliente.gradourgencia = this.datosAccion.gradourgencia;
                cliente.fecha = this.datosAccion.fecha;
                cliente.descripcion = this.datosAccion.descripcion;
                this.contratosSegunAmbito(cliente);
            });
        },
        calculoEntradaSalida(){
            this.clientesSelec.forEach(cliente => {
                var fechaEntrada = null;
                if (cliente === this.clientesSelec[0]){ //si es el primer cliente, la hora de entrada es igual a la de inicio
                    if(cliente.entrada == "00:00"){
                        cliente.fecha = this.sumarRestarDia(cliente.fecha, -1);
                    }
                    cliente.entrada = this.datosAccion.hora;
                    fechaEntrada = this.datosAccion.fecha; // igual con la fecha de entrada
                }
                else{ //para el resto de clientes la hora de entrada es igual a la de salida del cliente anterior
                    cliente.entrada = this.clientesSelec[(this.clientesSelec.findIndex(c => c === cliente)-1)].salida;
                    fechaEntrada = this.clientesSelec[(this.clientesSelec.findIndex(c => c === cliente)-1)].fecha;
                }
                let salida = this.calculoSalida(cliente.entrada, cliente.tiempoAccion.substring(0,2));

                if(salida.split(":")[0] == 24){ //si se acaba el dia
                    cliente.entrada = "00:00"; //cambiamos al dia siguiente
                    salida = this.calculoSalida(cliente.entrada, cliente.tiempoAccion.substring(0,2));
                    cliente.fecha = this.datosAccion.fecha;
                    cliente.fecha = this.sumarRestarDia(fechaEntrada, 1);
                }else{
                    if(cliente !== this.clientesSelec[0]){ //la fecha es la misma que en el cliente anterior
                        cliente.fecha = this.clientesSelec[(this.clientesSelec.findIndex(c => c === cliente)-1)].fecha;
                    }
                }

                cliente.salida = salida;
            });
        },
        sumarRestarDia(fecha, dias){
            var f = new Date(this.parseDate(fecha));
            f.setDate(f.getDate() + dias);
            return this.formatDate(f.toISOString().substr(0, 10));
        },
        calculoSalida(entrada, minutosAccion){
            let entradaSeparada = entrada.split(":");
            let minutos = Number(entradaSeparada[1])+Number(minutosAccion); //sumo los minutos
            let hora = entradaSeparada[0];
            if (minutos >= 60){
                hora = Number(hora) + 1;
                minutos = minutos - 60;
                if(minutos < 10){
                    minutos = '0'+ minutos
                }
            }
            return hora + ':' + minutos;
        },
        cambioForzado(){ //dejo el array igual que entra pero necesito forzar un cambio para que se actualice la hora en la tabla
            let c1 = this.clientesSelec[0];
            this.clientesSelec.splice(0,1); //quito el primer objeto
            this.clientesSelec.unshift(c1); //y lo vuelvo a poner
        },
        async guardar(){
            this.setLoading(true);
            let clienteFaltaDato = null;

            for (const cliente of this.clientesSelec){
                cliente.fecha=cliente.fecha.split("/").reverse().join("-"); //cambio formato fecha de DD/MM/YYYY a YYYY-MM-DD
                let delegacion = cliente.delegaciones.delegacionId;
                let comercialReferencia = this.comerciales.find(item => item.email === cliente.comercialEmail); 
                // obtener responsable de cuenta
                let respuestaResponsable = await axios.get(`/api/tecnicosCliente?cliente_id=${cliente.cliente_id}`);
                cliente.responsable_id = (this.tecnicos.find(tecnico => tecnico.email === respuestaResponsable.data[0].responsableCuenta))?.id;
                if (cliente.responsable_id === undefined){
                    cliente.responsable_id = 6 // Para los clientes que no tienen informado el responsable de cuenta, se crean con el usuario General (son partes de tareas varias, no es muy relevante)
                }
                if(comercialReferencia && delegacion){
                    cliente.delegacion_id = delegacion;
                    cliente.comercial_id = comercialReferencia.id;
                }else{
                    clienteFaltaDato = cliente.name;
                }
                cliente.contrato.id = cliente.contrato.contrato_id;
            }
            
            if(clienteFaltaDato !== null){
                this.setLoading(false);
                this.setSnackbar({
                    tipo: 'warning',
                    mensaje: 'No se han podido guardar las acciones porque el cliente ' + clienteFaltaDato + ' no tiene delegación y/o comercial informado en BC.'
                });
            }else{
                axios.post("/api/accionesmasivas", this.clientesSelec).then(respuesta => {
                    this.setLoading(false);
                    this.cancelar();
                    this.setSnackbar({
                        tipo: 'success',
                        mensaje: 'Datos guardados correctamente'
                    });
                }).catch(error => {
                    //console.log(error);
                    this.setLoading(false);
                    this.setSnackbar({
                        tipo: 'error',
                        mensaje: 'Error. No se han podido guardar los datos'
                    });
                });
            }
        },
        cancelar(){
            this.setDatosAccion('{}');
            this.setDialogListar(false);
        },
        clientesNoSelec(cliente){  
            if(!this.clientesSelec.includes(cliente)){
                return 'disabledRow';
            }
            else {
                this.contenidoDesc();
                // this.contenidoContrato();
                this.comprobarAmbitos();
                return '';
            }
        },
        asignarEstadoCheck(indeterminado, todos){
            this.checkIndet = indeterminado;
            this.selectAllFH = todos;
        },
        contenidoDesc(){
            let cantidadComentados = 0;
            let cantidadTotal = 0;
            this.clientesSelec.forEach(cliente => {
                if(cliente.descripcion || cliente.descripcion !== ""){
                    cantidadComentados++;
                }
                cantidadTotal++;
            });
            if(cantidadComentados == cantidadTotal){
                this.invalidDesc = false;
            }else{
                this.invalidDesc = true;
            }
        },
        contratosSegunAmbito(cliente) { 
            let contratos = cliente.contratos_ordenados.filter(contrato => contrato.ambitos.some(a => a.id === cliente.ambito.id));
            cliente.contrato = contratos[0];
            this.contenidoAmbitos(cliente);
            // cliente.contratosSegunAmbito = contratos;

            // if(cliente.contratosSegunAmbito && !cliente.contratosSegunAmbito.some(c => c.contrato_id === cliente.contrato.contrato_id)){ //si al cambiar el ambito ya no está el contrato que estaba marcado
            //     cliente.contrato = {};
            // }
            // this.contenidoContrato();
        },
        contenidoAmbitos(cliente) {
            let ambitosCliente = cliente.contrato.ambitos;
            cliente.ambitos = ambitosCliente;
            
            if(!ambitosCliente.some(a => a.id === cliente.ambito.id)){ //si al cambiar el contrato ya no está el ambito que estaba marcado
                cliente.ambito = {};
            }
            this.comprobarAmbitos();
            this.cambioForzado();
        },
        // contenidoContrato() {
        //     if(this.clientesSelec.length > 0 && this.clientesSelec.some(c => (c.contrato && Object.keys(c.contrato).length === 0) || !c.contrato)){
        //         this.disabledGuardar = true;
        //     }else {
        //         this.disabledGuardar = false;
        //     }
        // }
        comprobarAmbitos() {
            if(this.clientesSelec.length > 0 && this.clientesSelec.some(c => c.contrato && Object.keys(c.ambito).length === 0)){
                this.invalidAmbitos = true;
            }else {
                this.invalidAmbitos = false;
            }
        }
    },
    computed: {
        ...mapState('accionesMasivas', ['dialogListar', 'datosAccion']),
        ...mapGetters({
            tecnicos: "usuarios/tecnicos"
        }),
    },
    watch: {
        clientesSelec(){
            this.calculoEntradaSalida();
        }
    }
}
</script>
<style>
    .disabledRow {
        opacity: 0.5;
    }
    td:not(:first-of-type){ /* Agrego la clase a todos los td menos el primero */
        min-width: 7em;
    }
</style>